import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FF760A",
  "fill-rule": "evenodd",
  d: "M13 8.656a1 1 0 1 0-2 0v5a1 1 0 0 0 2 0zm-1 8.9a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M12.857 5.43a1 1 0 0 0-1.714 0L3.875 17.541a1 1 0 0 0 .857 1.514h14.536a1 1 0 0 0 .857-1.514zM9.427 4.4c1.166-1.942 3.98-1.942 5.145 0l7.268 12.113c1.2 2-.24 4.543-2.572 4.543H4.732c-2.332 0-3.772-2.544-2.572-4.543z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }